import React from 'react';

export const useActionWithin = (ref: any, children: React.MutableRefObject<any>[]) => {

  const handleMouseEnter = (e: MouseEvent) => {
    ref.current.classList.add('action-within');
  };

  const handleMouseLeave = (e: MouseEvent) => {
    ref.current.classList.remove('action-within');
  };

  React.useEffect(() => {
    for (let child of children) {
      child.current?.addEventListener('mouseenter', handleMouseEnter);
      child.current?.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      for (let child of children) {
        child.current?.removeEventListener('mouseenter', handleMouseEnter);
        child.current?.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [children]);
};
